import { Link, useSearchParams } from 'react-router-dom';
import { useDemoDockAuth, getDemoDockProxyBaseUrl, getDemoDockLoginUrl, getDemoDockLogoutUrl } from '../../components/DemoDock/auth';
import './DemoDock.css';

function getSafeReturnPath(value: string | null) {
    if (!value || !value.startsWith('/') || value.startsWith('//')) {
        return '/projects/demodock';
    }

    return value;
}

function getAbsoluteReturnUrl(path: string) {
    if (typeof window === 'undefined') {
        return path;
    }

    return new URL(path, window.location.origin).href;
}

function DemoDockLoginSignup() {
    const auth = useDemoDockAuth();
    const [searchParams] = useSearchParams();
    const returnPath = getSafeReturnPath(searchParams.get('returnTo'));
    const returnUrl = getAbsoluteReturnUrl(returnPath);
    const proxyBaseUrl = getDemoDockProxyBaseUrl();
    const loginUrl = getDemoDockLoginUrl(returnUrl);
    const logoutUrl = getDemoDockLogoutUrl(returnUrl);

    return (
        <section className="page demo-dock-login-page">
            <p className="project-detail-eyebrow">Demo Dock</p>
            <h1>Sign in</h1>
            <p className="project-detail-lead">
                Use your account to unlock the Demo Dock proxy and load live website previews.
            </p>

            <div className="demo-dock-login-panel">
                {auth.status === 'loading' ? (
                    <p>Checking your account...</p>
                ) : auth.status === 'authenticated' ? (
                    <>
                        <p className="demo-dock-login-status">Signed in as {auth.user?.name ?? 'your account'}.</p>
                        <div className="demo-dock-login-actions">
                            <Link to={returnPath}>Continue to Demo Dock</Link>
                            {logoutUrl ? <a href={logoutUrl}>Sign out</a> : null}
                        </div>
                    </>
                ) : (
                    <>
                        <p>
                            {proxyBaseUrl
                                ? 'Continue with Microsoft to sign in through Azure.'
                                : 'Local development mode is active, so Demo Dock is already unlocked on this machine.'}
                        </p>
                        <div className="demo-dock-login-actions">
                            {loginUrl ? <a href={loginUrl}>Continue with Microsoft</a> : null}
                            <Link to={returnPath}>{proxyBaseUrl ? 'Back to Demo Dock' : 'Open Demo Dock'}</Link>
                        </div>
                        {auth.status === 'error' ? <p className="demo-dock-login-error">{auth.error}</p> : null}
                    </>
                )}
            </div>
        </section>
    );
}

export default DemoDockLoginSignup;
